import {
    capitalizeFirstLetter,
    clearText,
    isDebug,
} from 'react-lf-tools'
import {getLocal, getSession, setLocal} from '../hooks/useStorage/useStorage.jsx'

import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'

const smoothScrolling = (id, time, top = 50, belowTheHeader = false) => {
    try {
        id = clearText(id)
        const target = document.getElementById(id)
        const elem = document.scrollingElement || document.documentElement
        const style = 'scrollTop'
        const unit = ''
        const from = window.scrollY
        const prop = true
        const to = ((target.offsetTop) - (((belowTheHeader) && (target.offsetTop < window.scrollY)) ? (top + 70) : (top)))
        const distance = Math.abs(to - from)
        switch (true) {
            case distance < 250:
                time = 350
                break
            case distance < 500:
                time = 300
                break
            case distance < 750:
                time = 250
                break
            case distance < 1000:
                time = 200
                break
            default:
                time = 50
        }
        if (!elem) return
        let start = new Date().getTime(),
            timer = setInterval(function () {
                let step = Math.min(1, (new Date().getTime() - start) / time)
                if (prop) {
                    elem[style] = (from + step * (to - from)) + unit
                } else {
                    elem.style[style] = (from + step * (to - from)) + unit
                }
                if (step === 1) {
                    clearInterval(timer)
                }
            }, 25);
        if (prop) {
            elem[style] = from + unit
        } else {
            elem.style[style] = from + unit
        }
    } catch (e) {

    }
}

const findListProductByName = (item) => {
    try {
        const array = []
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                if (products[p].product.toLowerCase().includes(item.toLowerCase()) && products[p].visibility.includes('DIGITALMENU')) {
                    array.push(products[p])
                }
            }
        }
        return array
    } catch (e) {
        console.error(e.message)
    }
    return []
}

const findProductBySku = (sku) => {
    try {
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                if (products[p].sku === sku) {
                    return products[p]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const findProductByName = (item) => {
    try {
        const menu = getLocal('menuItems', [])
        const listMenu = menu.filter((m) => (m.category !== 'Destaques'))
        for (const lm in listMenu) {
            const products = listMenu[lm].products
            for (const p in products) {
                if (products[p].product.toLowerCase().includes(item.toLowerCase())) {
                    return products[p]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const findVariationByName = (variations, item) => {
    try {
        for (const v in variations) {
            const options = variations[v].options
            for (const o in options) {
                if (options[o].option.toLowerCase().includes(item.toLowerCase())) {
                    return options[o]
                }
            }
        }
    } catch (e) {
        console.error(e.message)
    }
    return null
}

const newOrderId = () => setLocal('orderId', new Date().getTime().toString())

const tokenizeCard = (data, orderId) => {
    const token = JSON.stringify({
        cartao: data.number.replaceAll(' ', ''),
        nome: data.name,
        mes: data.month,
        ano: data.year,
        cvv: String(parseInt(data.cvc.split('').reverse().join('')) + parseInt(orderId.slice(-2)))
    })
    return btoa(token)
}

const log = (message, type = 'log') => {
    try {
        if (isDebug('5173')) {
            if (type === 'error')
                console.error(message)
            else if (type === 'table')
                console.table(message)
            else
                console.log(message)
        } else {
            //alert(message)
        }
    } catch (e) {

    }
}

const linkMenu = () => {
    const authkey = getLocal('authkey')
    const idStore = getLocal('idStore')
    const indexStore = getLocal('indexStore')
    console.log(`${import.meta.env.VITE_GET_MENU}?authkey=${authkey}&id=${idStore}&index=${indexStore}`)
}

const convertSearch = (search) => {
    try {
        search = search.replaceAll('=', '')
        search = search.substring(1)
        let searchReverse = search.split('').reverse().join('')
        try {
            search = decodeURIComponent(escape(atob(searchReverse)))
        } catch (e) {
            search = decodeURIComponent(escape(atob(search)))
        }
        search = searchEmJSON(search, 0)
        return search
    } catch (e) {
        console.error(e)
    }
}

const searchEmJSON = (search, index = 0) => {
    let pairs = search.substring(index).split('&'), objeto = {}, pair, i;
    for (i in pairs) {
        if (pairs[i] === '') continue
        pair = pairs[i].split('=')
        objeto[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
    }
    return objeto
}

const trackEventPixel = (event, data = {}) => {
    try {
        const store = getStoreIdentifier()
        ReactPixel.track(event, {...data, store: store})
    } catch (e) {
        console.error(e)
    }
}

const trackPageView = () => trackEventPixel('PageView')

const getStoreIdentifier = () => {
    try {
        const host = window.location.hostname
        const path = window.location.pathname.split('/')[1]

        if (host.includes('bitbar.app')) {
            return path || 'main'
        }

        return `${host}${path ? `/${path}` : ''}`
    } catch (e) {
        console.error('Erro no getStoreIdentifier:', e.message)
        return ''
    }
}

const trackEventAnalytics = (eventName, eventParams) => {
    try {
        const store = getStoreIdentifier()
        ReactGA.event(eventName, {
            ...eventParams,
            client_id: store
        })
    } catch (e) {
        console.error(e.message)
    }
}

const formatItemsAnalytics = items => {
    const array_items = []
    try {
        items.forEach(i => array_items.push({
            item_id: i.sku,
            item_name: capitalizeFirstLetter(`${i?.titulo || i?.product}`),
            price: i?.preco || i?.priceProduct,
            quantity: i?.quantidade || i?.amount
        }))
    } catch (e) {
        console.error(e.message)
    }
    return array_items
}

const getMode = () => {
    const sessionMode = getSession('mode', '')
    switch (sessionMode) {
        case 'table':
            return 'mesa'
        case 'card':
            return 'comanda'
        default:
            return 'balcao'
    }
}

const prices = (prices) => {
    try {
        const array = []
        prices.forEach((p) => {
            const include = array.some(obj => (obj.price === p.price))
            if (!include) array.push(p)
        })
        if (array.length === 1) array[0].description = ''
        return array
    } catch (e) {
        log(e.message, 'error')
    }
    return prices
}

const colors = (document) => {
    const {
        primaryColor,
        secundaryColor,
        bodyColor,
        textBodyColor,
        cardProduct,
        titleColor,
        descriptionColor,
        priceColor,
        buttonColor,
        textButtonColor,
        toolbarColor,
        textToolbarColor
    } = getLocal('colors')
    document.documentElement.style.setProperty('--primary-color', primaryColor)
    document.documentElement.style.setProperty('--secundary-color', secundaryColor)
    document.documentElement.style.setProperty('--body-color', bodyColor)
    document.documentElement.style.setProperty('--text-body-color', textBodyColor)
    document.documentElement.style.setProperty('--card-color', cardProduct)
    document.documentElement.style.setProperty('--title-color', titleColor)
    document.documentElement.style.setProperty('--description-color', descriptionColor)
    document.documentElement.style.setProperty('--price-color', priceColor)
    document.documentElement.style.setProperty('--button-color', buttonColor)
    document.documentElement.style.setProperty('--text-button-color', textButtonColor)
    document.documentElement.style.setProperty('--toolbar-color', toolbarColor)
    document.documentElement.style.setProperty('--text-toolbar-color', textToolbarColor)
}

const fixEncoding = (str) => {
    const decoder = new TextDecoder('utf-8')
    const bytes = new Uint8Array(str.split('').map(c => c.charCodeAt(0)))
    return decoder.decode(bytes)
}

const roundValues = value => parseFloat(value.toFixed(2))

const isPhoneInternational = (phone) => {
    try {
        if (typeof phone !== 'string') phone = phone.toString()

        // Remove tudo que não for número
        phone = phone.replace(/\D/g, '')

        // - Formatos aceitos:
        // - Brasil: 9 dígitos (sem DDD), 11 dígitos (com DDD), 13 (com 55)
        // - Argentina: começa com 549 + 10 dígitos
        // - Uruguai: começa com 598 + 8 dígitos (número móvel inicia com 9)

        // 🇧🇷 Brasil
        const isBrazil =
            (phone.length === 9 && /^[9]\d{8}$/.test(phone)) || // só celular sem DDD
            (phone.length === 11 && /^[1-9]{2}9\d{8}$/.test(phone)) || // DDD + celular
            (phone.length === 13 && /^55[1-9]{2}9\d{8}$/.test(phone)) // 55 + DDD + celular

        // 🇦🇷 Argentina
        const isArgentina =
            phone.length === 13 && /^549\d{10}$/.test(phone) // 549 + DDD + número

        // 🇺🇾 Uruguai
        const isUruguay =
            phone.length === 11 && /^5989\d{7}$/.test(phone) // 598 + celular

        return isBrazil || isArgentina || isUruguay
    } catch (e) {
        console.error(e.message)
        return false
    }
}

export {
    smoothScrolling,
    findListProductByName,
    findProductBySku,
    findProductByName,
    findVariationByName,
    newOrderId,
    tokenizeCard,
    log,
    linkMenu,
    convertSearch,
    trackEventPixel,
    trackPageView,
    getStoreIdentifier,
    trackEventAnalytics,
    formatItemsAnalytics,
    getMode,
    prices,
    colors,
    fixEncoding,
    roundValues,
    isPhoneInternational
}
